import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { signOut } from 'aws-amplify/auth';
import { Store } from '@ngrx/store';
import { Logout } from '../../core/_misc/_actions/auth.actions';
import { IntercomService } from '../../core/_services/intercom.service';
import { SessionService } from '../../core/_services/session.service';
import { AppState } from '../../core/reducers';

@Component({
  selector: 'cai-incorrect-login',
  templateUrl: './incorrect-login.component.html',
  styleUrls: ['./incorrect-login.component.scss'],
  standalone: false,
})
export class IncorrectLoginComponent {
  return = '';
  token: string;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly store: Store<AppState>,
    public readonly sessionService: SessionService,
    public readonly intercomService: IntercomService,
    public readonly router: Router,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.return = params.return ?? '';
      this.token = params.token;
    });
  }

  onLogout() {
    signOut()
      .then(() => {
        this.store.dispatch(new Logout());
        this.sessionService.clearLocalStorage();
        this.router.navigate(['/' + this.return.split('?')[0]], {
          queryParams: { token: this.token },
        });
      })
      .catch((err) => alert(err.message || "Can't logout"));
  }
}
